import { ClockIcon } from '@/components/icons/clock'
import { routes } from '@/config/routes'
import { cn } from '@/utils/cn'
import { Link } from 'react-router'

interface Props {
  protocolVaultUrl?: string
  className?: string
}

export const TxNotSupportedPanel = ({ protocolVaultUrl, className }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-2xl border bg-surface p-4 text-center',
        className
      )}
    >
      <ClockIcon size={48} className="shrink-0 text-accent" />
      <p className="font-medium text-heading-foreground text-xl">Transaction support coming soon</p>
      <p className="text-sm">
        In the meantime, you can check out other{' '}
        <Link to={routes.root} className="text-accent hocus:underline">
          opportunities
        </Link>
        {protocolVaultUrl && (
          <>
            {' '}
            or go to the protocol{' '}
            <a href={protocolVaultUrl} target="_blank" rel="noreferrer" className="text-accent hocus:underline">
              page
            </a>
          </>
        )}
        .
      </p>
    </div>
  )
}
